import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import Template from './modules/Template';
import User from './modules/User';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
        template: Template,
        user: User,
    },
    state: {

    },
    plugins: [
        createPersistedState({
            storage: window.sessionStorage,
            key: 'dance-crm-vuex',
            paths: ['template.perPages'],
        })
    ],
    mutations: {

    },
    actions: {

    },
})
